import { render, staticRenderFns } from "./VerticalTextImageSection.vue?vue&type=template&id=5ea53862&scoped=true&"
import script from "./VerticalTextImageSection.vue?vue&type=script&lang=js&"
export * from "./VerticalTextImageSection.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTextImageSection.vue?vue&type=style&index=0&id=5ea53862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea53862",
  null
  
)

export default component.exports